export const environment = {
  production: true,
  apiUrl: 'https://these.etappli.fr/'
};
